/**
 * @generated SignedSource<<ee2a0f9010246578c4ec3b6d47d9542e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type jiraTempoOauthTokenSection_company$data = {
  readonly tempoOauthTokenApplied: boolean | null;
  readonly jiraBaseUrl: string | null;
  readonly tempoOauthClientId: string | null;
  readonly tempoOauthClientSecret: string | null;
  readonly " $fragmentType": "jiraTempoOauthTokenSection_company";
};
export type jiraTempoOauthTokenSection_company$key = {
  readonly " $data"?: jiraTempoOauthTokenSection_company$data;
  readonly " $fragmentSpreads": FragmentRefs<"jiraTempoOauthTokenSection_company">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "jiraTempoOauthTokenSection_company",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tempoOauthTokenApplied",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "jiraBaseUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tempoOauthClientId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tempoOauthClientSecret",
      "storageKey": null
    }
  ],
  "type": "Company",
  "abstractKey": null
};

(node as any).hash = "9cf00816a64bfb2cce5c70ea646db180";

export default node;
